import { Component, OnInit, Input, OnDestroy, ViewChild, ElementRef } from '@angular/core';
import { Subject, BehaviorSubject, fromEvent } from 'rxjs';
import { SelectListItemDto, UserPermissionServiceProxy, UserPermissionAddressDto } from '../../../../../../../../../shared/service-proxies/service-proxies';
import { TestService } from 'test/service/test.service';
import { CustomLocalizationService } from '@app/views/pages/transpop/utility/customLocalization.service';
import { FormControl } from '@angular/forms';
import { debounceTime, tap, debounce } from 'rxjs/operators';

enum methodName {
	keyPressAddress = 0,
	onClickLocation = 1
}

@Component({
  selector: 'kt-to-request-distributor',
  templateUrl: './to-request-distributor.component.html',
  styleUrls: ['./to-request-distributor.component.scss']
})
export class ToRequestDistributorComponent implements OnInit, OnDestroy {


	/** control for the MatSelect filter keyword */
	public addressSearchFilter: FormControl = new FormControl();

	//Dynamic componentin basıldığı yere data göndermemizi sağlar.
	//Yani bu componentten başka bir componente burada ki datayı gönderiyoruz.
	dynamicComponentObject = new Subject();

	//Combobox içerisinde seçilen distributor objesi
	//selectedDistributor = new SelectListItemDto();
	selectedDistributor = new UserPermissionAddressDto();
	test = new UserPermissionAddressDto();

	//Combobox içerisine Doldurulacak olan Distributor Listesi
	//distributors = new BehaviorSubject<SelectListItemDto[]>([]);
	distributors = new BehaviorSubject<UserPermissionAddressDto[]>([]);
	distributorlist: UserPermissionAddressDto[] = [];
	initialDistributorlist: UserPermissionAddressDto[] = [];
	
	constructor(private _userPermissionService: UserPermissionServiceProxy,
		private _testService: TestService,
		private customLocalization: CustomLocalizationService) {

	
	}

	ngOnInit() {

		this._testService.setTitle(this.customLocalization.l("FE.PAGEHEADERS.ORDER.TOMAINWAREHOUSE.TOREQUESTDISTRIBUTOR.HEADER"));
		this._testService.setDesc(this.customLocalization.l("FE.PAGEHEADERS.ORDER.TOMAINWAREHOUSE.TOREQUESTDISTRIBUTOR.SUBHEADER"));

		//Kullanıcı bazlı gelen distributor listesi
		this._userPermissionService.getToRequestDistributorByUserAuths("")
			.subscribe(distributors => {

					this.distributors.next(distributors.addresses);
				    this.initialDistributorlist = distributors.addresses;
				
				//burada dönen data miktarı 150 den fazla mı bakılacak... Ona göre bazı durumlar eklenecek.
			});


		this.onKeyPressAddress();
		
	}


	//Combobox herhangi bir değiş olduğunda yakalamak için kullanıyoruz bu methodu.
	//(combo change işlemi)
	onChangeDistributor() {
		
		this.dynamicComponentObject.next(this.selectedDistributor);
	}



	isLocationNotFound: boolean = false;

	onKeyPressAddress() {

		//this.getLocationObjListByCity(methodName.keyPressAddress);
		
		this.addressSearchFilter.valueChanges
			.pipe(debounceTime(500))
				.subscribe(result => {

					this.isLocationNotFound = false;

					//Her koşulda işlem bu methoda girdiği için
					//Kullanıcı bir distiributor seçtikten sonra üzerine tıklayınca tekrar buraya geliyor
					//bu sebepten seçili olanın içerisi boşalıyordu.
					//Bizde eğer kayıtlı bir data varsa ve result null ise işlem burada sonlandır diyoruz
					if (this.selectedDistributor && result == "") {
						return;
					}

					//Eğer seçili bir data yoksa ve result içerisi boşsa ilk anda ki dataları comboya yükle diyoruz.
					if (result == "") {
						this.distributors.next(this.initialDistributorlist);

					}

					//Eğer arama yerine kullanıcı bir data girdiyse ve bu data 3 harften az ise ilk anda ki tüm datayı combobox içerisine dolduruyoruz.
					if (result != "" && this.addressSearchFilter.value.trim().length < 3) {

						return this.distributors.next(this.initialDistributorlist);
					}

					let searchDistributor = this.addressSearchFilter.value.trim();
					if (searchDistributor.length < 3) {
						
						return;
					}

			//Kullanıcı bazlı gelen distributor listesi
			this._userPermissionService.getToRequestDistributorByUserAuths(this.addressSearchFilter.value)
				.subscribe(distributors => {


					if (distributors.addresses.length < 1) {

						this.isLocationNotFound = true;
					}

					this.distributors.next(distributors.addresses);
					this.distributorlist = distributors.addresses;

					this.selectedDistributor = null;
					this.dynamicComponentObject.next(this.selectedDistributor);

				});

		});
		
		//setTimeout(() => {

		

		//}, 1000);
		


	}

	onClickLocation() {

		//this.getLocationObjListByCity(methodName.onClickLocation);

		if (this.distributors.getValue().length < 1) {
			this.distributors.next(this.initialDistributorlist);

		}
		else {
			this.dynamicComponentObject.next(this.selectedDistributor);
		}


		
	}



	////iki methodda kullanıyoruz adres ararken ve comboya ilk tıkladığımızda çalışır.
	//private getLocationObjListByCity(methodNm) {

	//	// get the search keyword
	//	let search = this.addressSearchFilter.value;

	//	if (search != "" && (methodName.onClickLocation == methodNm)) {
	//		return;
	//	}

	//	search = search.toLocaleUpperCase('tr-TR');
	//	// filter the banks
	//	this.distributors.next(
	//		this.distributorlist.filter(locationName => {

	//			//locationName.name.toLowerCase().indexOf(search) > -1
	//			//lokasyon adı ile aranan kelimeler arasında uyum varsa buraya gir be uyan isimleri next içerisine ata diyoruz.
	//			if (locationName.name.indexOf(search) > -1) {
	//				return locationName.name.indexOf(search) + 1;
	//			}
	//			//Eğer arana kelimeyle uyuşan bir data yokda lokasyonda birşey gösterme diyoruz.
	//			else {
	//				this.selectedDistributor = null;
	//				this.dynamicComponentObject.next(this.selectedDistributor);

	//			}
	//		})
	//	);

	//}

	ngOnDestroy() {

		this.dynamicComponentObject.unsubscribe();
		this.distributors.unsubscribe();

		this._testService.setTitle(" ");
		this._testService.setDesc(" ");
	}

}
